var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8a7 7 0 017-7h4a7 7 0 017 7v4a7 7 0 01-7 7H8a7 7 0 01-7-7V8z",
    fill: "url(#verified_svg__paint0_linear_20467_42301)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8a7 7 0 017-7h4a7 7 0 017 7v4a7 7 0 01-7 7H8a7 7 0 01-7-7V8z",
    stroke: "url(#verified_svg__paint1_linear_20467_42301)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.417 11.2L8.333 14l6.25-6.4L15 6l-1.667.4-5 5.2L6.667 10 5 9.6l.417 1.6z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "verified_svg__paint0_linear_20467_42301",
    x1: 0,
    y1: 10.189,
    x2: 20,
    y2: 10.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B83E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B67D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "verified_svg__paint1_linear_20467_42301",
    x1: 0,
    y1: 10.189,
    x2: 20,
    y2: 10.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B83E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B67D"
  })))));
}

export default SvgVerified;